import { Modal, useModals } from 'almanac-ui/Modal'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'

interface Props {
  onConfirm: (calendar_property_name: string) => void
}

export const NewDatePropertyModal = ({ onConfirm }: Props) => {
  const defaultName = 'Launch Date'
  const [name, setName] = useState(defaultName)
  const { closeModal } = useModals()

  const handleConfirm = () => {
    onConfirm(name || defaultName)
    closeModal()
  }

  return (
    <Modal.Root>
      <Modal.Header
        headingLevel={3}
        title="A new date property will be created for the calendar. What do you want to call it?"
      />
      <Modal.Content>
        <Input
          size="lg"
          name="Date Property Name"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          placeholder="Date"
          autoFocus
        />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={handleConfirm} size="lg">
            Create Property
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
